import { primaryColor } from "./status/primary.js";
const primary = (mode)=>{
    const color = primaryColor(mode);
    return {
        ...color,
        light: 'light' === mode ? color.lowContrast : color.highContrast,
        dark: 'light' === mode ? color.highContrast : color.lowContrast
    };
};
export { primary };

//# sourceMappingURL=primary.js.map